var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 22.5H3.75C2.475 22.5 1.5 21.525 1.5 20.25V11.25C1.5 9.975 2.475 9 3.75 9H5.25C6.525 9 7.5 9.975 7.5 11.25V20.25C7.5 21.525 6.525 22.5 5.25 22.5ZM3.75 10.5C3.3 10.5 3 10.8 3 11.25V20.25C3 20.7 3.3 21 3.75 21H5.25C5.7 21 6 20.7 6 20.25V11.25C6 10.8 5.7 10.5 5.25 10.5H3.75Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.5H11.25C9.975 22.5 9 21.525 9 20.25V3.75C9 2.475 9.975 1.5 11.25 1.5H12.75C14.025 1.5 15 2.475 15 3.75V20.25C15 21.525 14.025 22.5 12.75 22.5ZM11.25 3C10.8 3 10.5 3.3 10.5 3.75V20.25C10.5 20.7 10.8 21 11.25 21H12.75C13.2 21 13.5 20.7 13.5 20.25V3.75C13.5 3.3 13.2 3 12.75 3H11.25Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.5H18.75C17.475 22.5 16.5 21.525 16.5 20.25V7.5C16.5 6.225 17.475 5.25 18.75 5.25H20.25C21.525 5.25 22.5 6.225 22.5 7.5V20.25C22.5 21.525 21.525 22.5 20.25 22.5ZM18.75 6.75C18.3 6.75 18 7.05 18 7.5V20.25C18 20.7 18.3 21 18.75 21H20.25C20.7 21 21 20.7 21 20.25V7.5C21 7.05 20.7 6.75 20.25 6.75H18.75Z",
    fill: "#E1E1E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.4726f8a8.svg";
export { ForwardRef as ReactComponent };